module.exports = __webpack_public_path__ + "pizzeria.png?b0c0c7e8991e1488a781058f5e464f16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_images/offers/pizzeria.png
// module id = 107
// module chunks = 13